var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFeedTaskIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.46582 0H14.5342C15.3408 0 16 0.659363 15.9971 1.46564V5.5531C15.9971 6.35938 15.3379 7.01874 14.5312 7.01874H1.46582C0.65918 7.01874 0 6.35938 0 5.5531V1.46564C0 0.659363 0.65918 0 1.46582 0ZM2 5.02185H14V2.02185H2V5.02185Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5342 8.97815H1.46582C0.65918 8.97815 0 9.63751 0 10.4469V14.5344C0 15.3406 0.65918 16 1.46582 16H14.5312C15.3379 16 15.9971 15.3406 15.9971 14.5344V10.4469C16 9.63751 15.3408 8.97815 14.5342 8.97815ZM2 14H14V11H2V14Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeedTaskIcon);
export default __webpack_public_path__ + "static/media/FeedTaskIcon.ba9fb1db7e0dcd1b6ab74946d5e50544.svg";
export { ForwardRef as ReactComponent };